import * as React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { TableHead, Table, TableBody } from '@material-ui/core';
import { CustomTableRow, CustomTableCell, RowLabelCell } from '../Common/CustomTableComponents';
import EmptyCols from '../Common/EmptyCols';
import SubComponentRows from '../Common/SubComponentRows';
import { d3Indicators, d3EmptyIndicators, getFilteredIndicators } from '../Common/utils';
import TotalIndicator from '../Common/TotalIndicator';

const styles = (theme) => ({
  root: {
    // background: 'linear-gradient(180deg, #FFFFFF 0%, rgba(255, 255, 255, 0) 100%), #F2CE5C;',
    background: 'linear-gradient(180deg, #FFFFFF 0%, rgba(255, 255, 255, 0) 100%), #F0CA4D;',
  },
  body: {
    background: 'linear-gradient(180deg, #FFFFFF 0%, rgba(255, 255, 255, 0) 100%), #F0CA4D;',
  },
  footer: {
    // background: '#C4C4C4;',
  },
  boldCell: {
    fontWeight: 'bold',
    fontSize: '16px',
  },
});

const totalsColumns = {
  pointsEarned: 'Component Points Earned',
  PointsPossible: 'Component Points Possible',
  percentScore: 'Component Percent Score',
};
const totalsColumnsLength = Object.keys(totalsColumns).length;

const scoreColumns = {
  weight: 'Weight',
  score: 'Score',
};
const scoreColumnsLength = Object.keys(scoreColumns).length;

//  studentsListPath={studentsListPath + '/reading/meets/all'}
//  studentsListPath={studentsListPath + '/math/meets/all'}

const AcademicAchievement = ({
  classes,
  component,
  studentsListPath,
  handleGetStudentsList,
  profile,
  schoolTypeConversion,
  showAllTargets,
  showTenths,
  showAdditionalStudentGroups,
  tagColumns = {},
}) => {
  if (!component) return null;
  const indicatorsToUse = { ...getFilteredIndicators(d3Indicators, showAdditionalStudentGroups), ...tagColumns };
  const indicatorsToUseLength = Object.keys(indicatorsToUse).length;

  return (
    <Table className={classes.root}>
      <TableHead>
        <CustomTableRow>
          <CustomTableCell />
          {Object.entries(indicatorsToUse).map(([key1, label1]) => (
            <CustomTableCell key={key1}>{label1}</CustomTableCell>
          ))}

          {Object.entries(totalsColumns).map(([key1, label1]) => (
            <CustomTableCell key={key1}>{label1}</CustomTableCell>
          ))}
          {Object.entries(scoreColumns).map(([key1, label1]) => (
            <CustomTableCell key={key1}>{label1}</CustomTableCell>
          ))}
        </CustomTableRow>
      </TableHead>
      <TableBody>
        <CustomTableRow>
          <RowLabelCell>Academic Achievement - Reading </RowLabelCell>
          <EmptyCols length={indicatorsToUseLength + totalsColumnsLength + scoreColumnsLength} />
        </CustomTableRow>
        <SubComponentRows
          label="Reading Achievement"
          componentCode="academicAchievement"
          totalsColumnsLength={totalsColumnsLength}
          scoreColumnsLength={scoreColumnsLength}
          counts={component.reading.numerator}
          totals={component.reading.denominator}
          percents={component.reading.rate || d3EmptyIndicators}
          targets={component.reading.targets}
          totalIndicators={component.reading.totalIndicators}
          eligibles={component.reading.eligible || d3EmptyIndicators}
          metTargets={component.reading.metTarget || d3EmptyIndicators}
          handleGetStudentsList={handleGetStudentsList}
          profile={profile}
          schoolTypeConversion={schoolTypeConversion}
          studentsListPath={studentsListPath ? studentsListPath + '/reading/d3Met' : null}
          studentsListPathDoesNotMeet={studentsListPath ? studentsListPath + '/reading/d3NotMet' : null}
          componentIndicators={component.componentIndicators}
          showAllTargets={showAllTargets}
          showTenths={showTenths}
          displayedIndicators={indicatorsToUse}
          showAdditionalStudentGroups={showAdditionalStudentGroups}
        />
        <CustomTableRow>
          <RowLabelCell>Academic Achievement - Math </RowLabelCell>
          <EmptyCols length={indicatorsToUseLength + totalsColumnsLength + scoreColumnsLength} />
        </CustomTableRow>
        <SubComponentRows
          label="Math Achievement"
          componentCode="academicAchievement"
          totalsColumnsLength={totalsColumnsLength}
          scoreColumnsLength={scoreColumnsLength}
          counts={component.math.numerator}
          totals={component.math.denominator}
          percents={component.math.rate || d3EmptyIndicators}
          targets={component.math.targets}
          totalIndicators={component.math.totalIndicators}
          eligibles={component.math.eligible || d3EmptyIndicators}
          metTargets={component.math.metTarget || d3EmptyIndicators}
          handleGetStudentsList={handleGetStudentsList}
          profile={profile}
          schoolTypeConversion={schoolTypeConversion}
          studentsListPath={studentsListPath ? studentsListPath + '/math/d3Met' : null}
          studentsListPathDoesNotMeet={studentsListPath ? studentsListPath + '/math/d3NotMet' : null}
          componentIndicators={component.componentIndicators}
          showAllTargets={showAllTargets}
          showTenths={showTenths}
          displayedIndicators={indicatorsToUse}
          showAdditionalStudentGroups={showAdditionalStudentGroups}
        />
      </TableBody>
      <TotalIndicator
        footerClass={classes.footer}
        title="Achievement Total"
        indicatorsLength={indicatorsToUseLength}
        totalIndicators={component.totalIndicators}
      />
    </Table>
  );
};
AcademicAchievement.propTypes = {
  component: PropTypes.object,
  classes: PropTypes.any,
  handleGetStudentsList: PropTypes.func,
  studentsListPath: PropTypes.string,
  profile: PropTypes.object,
  schoolTypeConversion: PropTypes.string,
  showAllTargets: PropTypes.bool,
  showTenths: PropTypes.bool,
};

export default withStyles(styles)(AcademicAchievement);
